export default __webpack_public_path__ + "static/media/080.c2cd27e7.jpg";